import { apiRequest } from "@/services/api/apiClient.js";

export function lpbuilder({
    method = "get",
    url,
    params = {},
    body = {},
    headers = {},
    responseType,
}) {
    return apiRequest({
        client: window.API_LPBUILDER,
        method,
        url: `/api${url}`,
        params,
        body,
        headers,
        responseType,
    });
}
